import {ToastModel} from '@syncfusion/ej2-notifications';

export class ToastErrorModel implements ToastModel {
  readonly cssClass = 'is-error';
  width: '400px';
  public timeOut: 5000;
  icon = 'icon-minus-circle';
  title = '';

  constructor(public content: string, title?: string, iconCss?: string) {
    if (iconCss) {
      this.icon = iconCss;
    }

    if (title) {
      this.title = title;
    }
  }
}
